import { useNavigate } from "react-router-dom";
import { MenuTop } from '../../../components/menu/top/menu-top';
import IconButtonComponent from "../../../components/Icon/icon-button";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import AssignmentIcon from '@mui/icons-material/Assignment';
import '../styles/causale-page.css';

export const CausalePage = () => {
    const navigate = useNavigate();
    
    return (
        <div>
            <MenuTop />
            <div className="causale-page-container">
                <h1>Painel Causale</h1>
                
                <div className="causale-buttons-container">
                    <IconButtonComponent
                        label="Listar Usuários"
                        icon={<PersonAddIcon />}
                        onClick={() => navigate('/admin-painel/users')}
                    />
                    <IconButtonComponent
                        label="Novo Usuário"
                        icon={<PersonAddIcon />}
                        onClick={() => navigate('/admin-painel/add-user')}
                    />
                     <IconButtonComponent
                        label="Gerenciar Testes"
                        icon={<AssignmentIcon />}
                        onClick={() => navigate('/admin-painel/tests-management')}
                    />
                </div>
            </div>
        </div>
    );
}